import { Injectable } from '@angular/core';
import { UrlTree, DefaultUrlSerializer } from '@angular/router';

@Injectable()
export class CustomUrlSerializerService extends DefaultUrlSerializer {
  constructor() {
    super();
  }
  public override parse(url: string): UrlTree {
    const cleanUrl = url.replace(/(.*?)\?(.*?)\?(.*)/, '$1?$2&$3');
    const urlSplit = cleanUrl.split('?');
    const queryParams = urlSplit[1];

    // ↓↓↓ اینجا lowercase اضافه کردیم ↓↓↓
    let newUrl = this.replacer(decodeURI(urlSplit[0].toLowerCase()));

    if (queryParams) {
      newUrl += `?${decodeURI(queryParams)}`;
    }

    return super.parse(newUrl);
  }


  public override serialize(tree: UrlTree): string {
    let result = super.serialize(tree);

    // اگه query string وجود داره جداش کنیم
    const [path, query] = result.split('?');

    // شرط: مسیر نباید فایل باشه (یعنی نقطه نداشته باشه) و اسلش هم آخرش نباشه
    const shouldHaveTrailingSlash =
      !path.includes('.') && !path.endsWith('/');

    let newPath = shouldHaveTrailingSlash ? path + '/' : path;

    return query ? `${newPath}?${query}` : newPath;
  }

  private replacer(str: string): string {
    return str.replace(/[()]/g, (c) => '%' + c.charCodeAt(0).toString(16));
  }
}
